import axios from 'axios'
import { useAuthStore } from '@/app/store/authStore'
import { receiverApi } from './config'
import { routes } from '../config/routes'

const authAxios = axios.create({
  baseURL: receiverApi,
  timeout: 30000,
})

authAxios.interceptors.request.use(
  (config) => {
    const { user } = useAuthStore.getState()

    if (user?.AuthId) {
      config.headers['X-Auth'] = user.AuthId
    }

    config.headers['Content-Type'] = 'application/json'

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

let isHandlingUnauthorized = false

authAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !isHandlingUnauthorized) {
      isHandlingUnauthorized = true
      try {
        await useAuthStore.getState().logout()
      } finally {
        isHandlingUnauthorized = false
        window.location.href = routes.login
      }
    }

    return Promise.reject(error)
  }
)

export default authAxios
